import Vue from 'vue'
import VueRouter from 'vue-router'


import store from '../store'

import * as jwtDecode  from 'jwt-decode'

import CMS from "@/views/CMS.vue"
import VOID from "@/views/void.vue"
//import Rubros from "../components/Archivos/Rubros/Rubros.vue"


Vue.use(VueRouter)

async function redirectIfNotAuth (to, from, next) {
  console.log("redirectIfNotAuth")
  
  let r=""
  let decode
  let token = localStorage.getItem('token')

  try {
    decode = await jwtDecode(token) 

    if (token && decode && decode.login){
      if (store.state._session.login){
        localStorage.setItem('route', to.path)
      }
      else {
        store.state._session={
          login: decode.login,
          modulo: decode.modulo,
          redir: decode.redir,
          token,
          userID: decode.userID,
          userName: decode.userName,
          userType: decode.userType,
          usr: decode.usr
        }
        console.log("window.innerWidth",window.innerWidth)
        if (window.innerWidth>1264) {store.state.menuPpal.drawer=true}
        next(localStorage.getItem('route'))
  
      }


     
      next()

    }
    else {
      console.log("limpiar state")
      localStorage.clear()
      store.state._session=undefined

      if (to.path!="/") {
        next("/")
      } else {next()}
    }
  }
  catch {
    console.log("error")
    if (to.path!="/") {
      next("/")
    } else {next()}
  }
  
    
  //next()

  //console.log(decode)



/*
  console.log("to   ->",to)
  console.log("from ->", from)
  console.log("next -> ",next)
  console.log("redirectIfNotAuth -> ",store.state['_session'])

  const estado=await getState('_session')

  console.log("estado", estado)




  const user = store.state.usr!=undefined?await getUserState() : null
  if (user === null) {
    next('/login')
  } else {
    next()
  }
*/



  //next()
}


function getState (state) {
  return new Promise((resolve, reject) => {
    if (store.state[state] === undefined) {
      const unwatch = store.watch(
        () => store.state[state],
        (value) => {
          unwatch()
          resolve(value)
        }
      )
    } else {
      resolve(store.state[state])
    }
  })
}

const routes = [
  {
    path: '/',
    meta :{ title:process.env.VUE_APP_TITLE},
    beforeEnter: redirectIfNotAuth
    //redirect: { name: 'login' }
  },
  {
    path:"/productos",
    name:'productos',
    beforeEnter: redirectIfNotAuth, 
    component:  () => import(/*  webpackChunkName: "productos" */ '../components/Productos/Productos.vue')
  },
  {
    path:"/usuarios/",
    name:'Usuarios',
    beforeEnter: redirectIfNotAuth, 
    component:  VOID,
    children: [ 
      {
        path: 'clientes',
        name: 'Clientes',
        beforeEnter: redirectIfNotAuth, 
        component:  () => import(/*  webpackChunkName: "clientes" */ '../componentsByM/Usuarios/Clientes.vue')
      },
      {
        path: 'viajantes',
        name: 'Viajantes',
        beforeEnter: redirectIfNotAuth, 
        component:  () => import(/*  webpackChunkName: "viajantes" */ '../componentsByM/Usuarios/Viajantes.vue')
      },
    ]
  },
  {
    path: '/archivos',
    name: 'Archivos',
    component:VOID,
    children: [ 
        {
          path: 'marcas',
          name: 'Marcas',
          beforeEnter: redirectIfNotAuth, 
          component:  () => import(/*  webpackChunkName: "marcas" */ '../componentsByM/Archivos/Marcas/Marcas.vue')
        }, 
        {
          path: 'categorias',
          name: 'Categorías',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "categorias" */ '../components/Archivos/Rubros/Rubros.vue')
        }, 
        {
          path: 'subcategorias',
          name: 'Sub Categorías',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "subcategorias" */ '../components/Archivos/SubRubros/SubRubros.vue')
        }, 
        {
          path: 'marcas_autos',
          name: 'Marcas Autos',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "marcasautos" */ '../components/Archivos/Autos/MarcasAutos.vue')
        }, 
        {
          path: 'modelos_autos',
          name: 'Modelos Autos',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "modelosautos" */ '../components/Archivos/Autos/ModelosAutos.vue')
        }, 
        {
          path: 'motores_autos',
          name: 'Motores',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "motorsautos" */ '../components/Archivos/Autos/MotoresAutos.vue')
        }, 
        {
          path: 'marcas_equiv',
          name: 'Marcas Equivalentes',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "marcasequiv" */ '../components/Archivos/Marcas/MarcasEquiv.vue')
        }, 
        {
          path: 'datos_tecnicos',
          name: 'Datos Técnicos',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/*  webpackChunkName: "titulos" */ '../components/Archivos/Titulos/Titulos.vue')
        }, 
        //{ path: 'confirm', component: '' }
    ] 
  },

  {
    path: '/listas',
    name: 'Listas',
    component: VOID,
    beforeEnter: redirectIfNotAuth,
    children: [ 
        {
          path: 'listas_precios/',
          name: 'Listas Precios',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/* webpackChunkName: "ListasPrecios" */ '../components/Listas/ListasPrecios.vue') 
        }, 
        { 
          path: 'importar_precios/', 
          name:'Importar Precios CONEX',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/* webpackChunkName: "ImportarPrecios" */ '../components/Listas/ImportarPrecios.vue')
        },
        //{ path: 'confirm', component: '' }
    ] 
  },

  {
    path: '/usuarios',
    name: 'Usuario',
    component: VOID,
    beforeEnter: redirectIfNotAuth,
    children: [ 
        {
          path: 'pre_registro/',
          name: 'Pre Registro',
          beforeEnter: redirectIfNotAuth, 
          component: () => import(/* webpackChunkName: "PreUsuario" */ '../components/Usuarios/Pre-Usuarios.vue') 
        }, 
        { 
          path: 'pedidos/', 
          name:'Pedidos',
          beforeEnter: redirectIfNotAuth, 
          component: CMS 
        },
        //{ path: 'confirm', component: '' }
    ] 
  }
]




const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})


router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;


  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
